/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Btn_SigninInputs */

const en_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

const es_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const de_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

const zh_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const ar_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الدخول`)
};

const fr_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const vi_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập`)
};

const sw_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia`)
};

const th_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบ`)
};

const bs_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijavi se`)
};

const ja_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン`)
};

const ko_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인`)
};

const pt_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const it_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi`)
};

const sv_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in`)
};

const nl_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen`)
};

const da_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind`)
};

const nb_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn`)
};

const fi_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään`)
};

const pl_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się`)
};

const ru_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

const tr_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş yap`)
};

const hi_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साइन इन करें`)
};

const id_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk`)
};

const ms_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk`)
};

const cs_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlásit se`)
};

const el_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σύνδεση`)
};

const he_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברות`)
};

const af_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld aan`)
};

const hu_auth_btn_signin = /** @type {(inputs: Auth_Btn_SigninInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bejelentkezés`)
};

/**
* | output |
* | --- |
* | "Sign in" |
*
* @param {Auth_Btn_SigninInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_btn_signin = /** @type {((inputs?: Auth_Btn_SigninInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Btn_SigninInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_btn_signin(inputs)
	if (locale === "de") return de_auth_btn_signin(inputs)
	if (locale === "zh") return zh_auth_btn_signin(inputs)
	if (locale === "ar") return ar_auth_btn_signin(inputs)
	if (locale === "fr") return fr_auth_btn_signin(inputs)
	if (locale === "vi") return vi_auth_btn_signin(inputs)
	if (locale === "sw") return sw_auth_btn_signin(inputs)
	if (locale === "th") return th_auth_btn_signin(inputs)
	if (locale === "bs") return bs_auth_btn_signin(inputs)
	if (locale === "ja") return ja_auth_btn_signin(inputs)
	if (locale === "ko") return ko_auth_btn_signin(inputs)
	if (locale === "pt") return pt_auth_btn_signin(inputs)
	if (locale === "it") return it_auth_btn_signin(inputs)
	if (locale === "sv") return sv_auth_btn_signin(inputs)
	if (locale === "nl") return nl_auth_btn_signin(inputs)
	if (locale === "da") return da_auth_btn_signin(inputs)
	if (locale === "nb") return nb_auth_btn_signin(inputs)
	if (locale === "fi") return fi_auth_btn_signin(inputs)
	if (locale === "pl") return pl_auth_btn_signin(inputs)
	if (locale === "ru") return ru_auth_btn_signin(inputs)
	if (locale === "tr") return tr_auth_btn_signin(inputs)
	if (locale === "hi") return hi_auth_btn_signin(inputs)
	if (locale === "id") return id_auth_btn_signin(inputs)
	if (locale === "ms") return ms_auth_btn_signin(inputs)
	if (locale === "cs") return cs_auth_btn_signin(inputs)
	if (locale === "el") return el_auth_btn_signin(inputs)
	if (locale === "he") return he_auth_btn_signin(inputs)
	if (locale === "af") return af_auth_btn_signin(inputs)
	if (locale === "hu") return hu_auth_btn_signin(inputs)
	return en_auth_btn_signin(inputs)
});